import useClevertapForSrp from '@/src/hooks/analytics/clevertap/srp'
import useSrpGtmEvent from '@/src/hooks/analytics/gtm/srp'
import useSearchResults from '@/src/hooks/srp/useSearchResults'
import type { FlightCard } from '@/src/types/flight'
import { getFlightData, getMulticityFlightData } from '@/src/utils/srp/flightResultsUtil'
import { getRouteSummaries } from '@/src/utils/srp/routeUtils'
import { useLocale, useTranslations } from 'next-intl'
import { useEffect } from 'react'
import { FlightResults } from './flightResults'
import { MulticityFlightResults } from './multicityFlightResults'

interface FlightResultsContainerProps {
    onBookFlight?: (flight: FlightCard) => void
    onViewDetails?: (flight: FlightCard) => void
    onSortByPrice?: () => void
    isBookingInProgress?: boolean
    loadingFlightKey?: string | null
    limitedView?: boolean
    limitedCount?: number
    showLoadMore?: boolean
    onLoadMore?: () => void
}

const FlightResultsWrapper: React.FC<FlightResultsContainerProps> = ({
    onBookFlight,
    onViewDetails,
    onSortByPrice,
    isBookingInProgress,
    loadingFlightKey,
    limitedView = false,
    limitedCount = 5,
    showLoadMore = false,
    onLoadMore
}) => {
    const locale = useLocale()
    const isArabic = locale === 'ar'
    const tCommon = useTranslations('common')
    const tFlightDetails = useTranslations('srpFlightDetails')
    const { jsons, sectors, selectedLegGroupedCards, smartPreferenceGroupedCards, isPerPaxPricingEnabled, isMulticity } =
        useSearchResults()
    const { airline_names = {}, secs, ap = {} } = jsons || {}
    const sectionArray = Array.isArray(secs) ? secs : secs ? Object.values(secs) : []
    const summary = getRouteSummaries(sectionArray, ap, isArabic)

    const { triggerSrpEvent } = useClevertapForSrp()
    const { pushEventToDataLayer } = useSrpGtmEvent()

    useEffect(() => {
        triggerSrpEvent('Air_PageLoad', {
            page_load_time: Math.round(performance.now())
        })
        pushEventToDataLayer({
            event: 'page_view_flight_search_results',
            page_category: 'home'
        })
    }, [])

    if (isMulticity) {
        return (
            <MulticityFlightResults
                getMulticityData={flight =>
                    getMulticityFlightData({
                        flight,
                        airline_names,
                        sectors: sectors!,
                        translationsFn: tCommon,
                        isPerPaxPricingEnabled
                    })
                }
                groupedEntries={selectedLegGroupedCards}
                route={summary.join(' | ')}
                onBookFlight={onBookFlight}
                onViewDetails={onViewDetails}
                tCommon={tCommon}
                tFlightDetails={tFlightDetails}
                isBookingInProgress={isBookingInProgress}
                loadingFlightKey={loadingFlightKey}
            />
        )
    }

    return (
        <FlightResults
            getFlightData={flight =>
                getFlightData({
                    flight,
                    airline_names,
                    sectors: sectors!,
                    translationsFn: tCommon,
                    isPerPaxPricingEnabled
                })
            }
            groupedEntries={selectedLegGroupedCards}
            smartPreferenceGroupedCards={smartPreferenceGroupedCards}
            route={summary.join('|')}
            // selectedDate={selectedDate}
            // onDateChange={onDateChange}
            onBookFlight={onBookFlight}
            onViewDetails={onViewDetails}
            onSortByPrice={onSortByPrice}
            sectors={sectors}
            tCommon={tCommon}
            tFlightDetails={tFlightDetails}
            isBookingInProgress={isBookingInProgress}
            loadingFlightKey={loadingFlightKey}
            limitedView={limitedView}
            limitedCount={limitedCount}
            showLoadMore={showLoadMore}
            onLoadMore={onLoadMore}
        />
    )
}

export { FlightResultsWrapper }
export default FlightResultsWrapper
